import { useEffect, useState } from "react";
import { api } from "../lib/api";

let cache = null;
const loadPhotos = () => {
  if (!cache) cache = api.get("/staff/photos").then((r) => r.data).catch(() => ({}));
  return cache;
};
const TINTS = ["#ffe4d6", "#e3f6ee", "#ece7ff", "#e0f0fb", "#fff3c9"];

export const Avatar = ({ name, size = 22 }) => {
  const [photos, setPhotos] = useState({});
  const [broken, setBroken] = useState(false);
  useEffect(() => { loadPhotos().then(setPhotos); }, []);
  if (!name) return null;
  const src = photos[name];
  const style = { width: size, height: size, fontSize: size * 0.42 };
  if (src && !broken) return <img src={src} alt={name} referrerPolicy="no-referrer" onError={() => setBroken(true)} data-testid={`avatar-photo-${name}`} className="rounded-full object-cover shrink-0" style={style} />;
  const tint = TINTS[[...name].reduce((a, c) => a + c.charCodeAt(0), 0) % TINTS.length];
  return <span data-testid={`avatar-initials-${name}`} className="rounded-full shrink-0 inline-flex items-center justify-center font-semibold text-foreground/70" style={{ ...style, background: tint }}>{name.slice(0, 1).toUpperCase()}</span>;
};

export const Staff = ({ name, size }) => (
  name ? <span className="inline-flex items-center gap-1.5 align-middle"><Avatar name={name} size={size} /><span>{name}</span></span> : <span>—</span>
);
